export default "__VITE_ASSET__dd08eacf__"